import { useMemo } from 'react';
import { useUser } from '../Context/UserContext';

export const useEarliestAgendaSpace = () => {
  const { user } = useUser();

  const earliestSpace = useMemo(() => {
    const rawAvailability = user?.professional?.earliest_availability;

    if (!rawAvailability?.available_from) {
      return null;
    }

    return {
      space: new Date(rawAvailability.available_from),
      timezone: rawAvailability.timezone || 'UTC',
      slotDuration: rawAvailability.slot_duration || 30,
      updatedAt: rawAvailability.updated_at,
    };
  }, [user]);

  return {
    earliestSpace,
    isLoading: false,
    error: null,
  };
};